import { ApiBase } from "~/extensions/api";
import { FindNyukyoshaCommand } from "./commands/FindNyukyoshaCommand";
import { GetNyukyoshaCommand } from "./commands/GetNyukyoshaCommand";
export class NyukyoshaApi extends ApiBase {
    /**検索API */
    find(model, pagination) {
        let command = new FindNyukyoshaCommand(model);
        pagination.applyTo(command);
        return this.request(command);
    }
    /**検索API */
    get(nyukyokeiyakuNo) {
        let command = new GetNyukyoshaCommand(nyukyokeiyakuNo);
        return this.request(command);
    }
}
